import { motion } from 'framer-motion';
import { ArrowDownIcon } from '@heroicons/react/24/outline';

export default function WhoWeAre() {
  return (
    <section className="relative py-24 transition-colors duration-300 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mb-4 flex items-center gap-2">
          <span className="h-2 w-2 flex-none rounded-sm bg-secondary" aria-hidden="true" />
          <p className="text-xs font-semibold uppercase tracking-[0.3em] text-secondary-dark dark:text-secondary">Who we are</p>
        </div>

        <div className="grid gap-8 lg:grid-cols-[1fr_18rem] lg:items-start">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="max-w-3xl text-pretty text-3xl font-semibold leading-snug tracking-tight sm:text-4xl lg:text-5xl"
          >
            <span className="text-gray-950 dark:text-white">Afroawi partners with ambitious teams</span>{' '}
            <span className="text-gray-400 dark:text-gray-500">to design and ship software with real, lasting impact.</span>
          </motion.h2>

          <p className="text-sm leading-6 text-gray-500 dark:text-gray-400 lg:pt-2">
            We shorten the distance between a good idea and a product people actually use, by keeping strategy, design, and engineering under one roof.
          </p>
        </div>

        <div className="mt-16 flex justify-center">
          <div className="flex h-16 w-16 rotate-45 items-center justify-center rounded-2xl bg-secondary shadow-lg shadow-secondary/20">
            <ArrowDownIcon className="h-6 w-6 -rotate-45 text-primary" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}
